import React from "react";

function Input ({label, name, placeholder, type, value, onChange}){
    return(
        <div style={{marginBottom:'15px'}}>
            <label>
                {label}
            </label>

            <input placeholder={placeholder} type={type} value={value} name={name} onChange={onChange}>
            </input>

        </div>
    );
}

export default Input;